export default __webpack_public_path__ + "static/media/style-artisticAtlantic.cb794f8e.jpg";